import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import BaseScreen from './presentation/components/BaseScreen';
import HomePageScreen from './presentation/screens/HomePageScreen/HomePageScreen';
import AboutScreen from './presentation/screens/AboutScreen/AboutScreen';
import ArticlesScreen from './presentation/screens/ArticlesScreen/ArticlesScreen';
import ArticleDetailScreen from './presentation/screens/ArticleDetailScreen/ArticleDetailScreen';
import EventsScreen from './presentation/screens/EventsScreen/EventsScreen';
import EventDetailScreen from './presentation/screens/EventDetailScreen/EventDetailScreen';
import ContactScreen from './presentation/screens/ContactScreen/ContactScreen';
import NotFoundScreen from './presentation/screens/NotFoundScreen/NotFoundScreen';

function App() {
  return (
    <Router>
      <BaseScreen>
        <Routes>
          <Route path="/" element={<HomePageScreen />} />
          <Route path="/about" element={<AboutScreen />} />
          <Route path="/articles" element={<ArticlesScreen />} />
          <Route path="/articles/:id" element={<ArticleDetailScreen />} />
          <Route path="/events" element={<EventsScreen />} />
          <Route path="/events/:id" element={<EventDetailScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </BaseScreen>
    </Router>
  );
}

export default App;
